(function () {
    'use strict';

    angular
      .module('app.cart.testoonCodeVerification', [])

      .directive('testoonCodeVerification', function () {

          return {
              restrict: 'A',
              bindToController: {
                  cartCtrl: '<',
                  codeFormat: '@'
              },
              controllerAs: 'codeVerificationCtrl',

              controller: ["HttpService", function (HttpService) {
                  var ctrl = this;
                  var orig;

                  ctrl.text = '';

                  ctrl.$onInit = function () {
                      orig = ctrl.cartCtrl.NextTooltip;
                      ctrl.cartCtrl.validCode = false;
                  };

                  ctrl.codeVerification = function () {
                      if (ctrl.form.$valid) {
                          HttpService.post({
                              url: 'Cart/CodeVerification?code=' + encodeURI(ctrl.text)
                          })
                          .then(function (results) {
                              ctrl.cartCtrl.validCode = results === 'OK';
                          });
                      }
                      else {
                          ctrl.cartCtrl.validCode = false;
                      }
                  }
              }]
          }
      });

})();